import { ID } from '../../utils/codecUtils';
import { hookInterfaceSchema } from '../models';
import { patchHookInterfacePayloadSchema } from './patch.schema';

export type PatchHookInterfacePayload = {
  name: string;
  description: string;
  payload: Record<string, unknown>;
  metadata: Record<string, unknown>;
  type: string;
};

export const patch = (id: ID, payload: PatchHookInterfacePayload) => {
  return {
    endpoint: `/hook_interfaces/${id}`,
    method: 'PATCH',
    payload,
    responseSchema: hookInterfaceSchema,
    payloadSchema: patchHookInterfacePayloadSchema,
  } as const;
};
